import 'bootstrap/dist/css/bootstrap.min.css'
import Login from './Login';
import Dashboard from './Dashboard';
const code = new URLSearchParams(window.location.search).get('code');
 
function App() {
  if (!code) {
    return (
      <Login/>
    );
  } else {
    return (
      <Dashboard code={code}/>
    );
  }
}

export default App;
